import {
  TrackV2OrderDetailsQuery,
  TrackV2OrderDetailsQueryVariables
} from '@data/__generated__/types.main'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useRouter} from 'next/router'

export default function useOrderDetails() {
  const router = useRouter()
  const {orderId} = router.query
  const {order} = useApolloQuery<TrackV2OrderDetailsQuery, TrackV2OrderDetailsQueryVariables>({
    query: gql`
      query trackV2OrderDetails($orderId: ID!) {
        order(orderId: $orderId) {
          _id

          orderStatus
          deliveryType

          totalPrice
          couponDiscount
          couponCode
          couponId
          couponName
          baseTotalPrice
          overchargeDiscount
          baseItemsPrice
          amountToPay
          tipAmount
          deliveryFee
          bagAmount
          paymentType
          paymentMethodLabel
          paymentStatus
          loyaltyTransaction {
            _id
            amount
            loyaltyName
          }
          cardId
          items {
            _id
            productName
            amount
            unitPrice
            descriptionItems {
              title
              selections
            }
          }
          isScheduled
          saleInvoice {
            _id
            fileURL
          }
          deliveryDuration
        }
      }
    `,
    variables: {orderId: orderId as string},
    fetchPolicy: 'cache-first'
  })

  return order
}
